const getCode = (word: string, table: string[][]): string[] => {
  const syllables = word.split("|");

  const alphabet = "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ";

  return syllables.map((syllable) => {
    for (let row = 0; row < table.length; row++) {
      for (let col = 0; col < table[row].length; col++) {
        if (table[row][col] === syllable) {
          return `${alphabet[row]}${col + 1}`;
        }
      }
    }

    return "?";
  });
};
export default getCode;